export default __webpack_public_path__ + "img/Inter-Medium_da6143a.woff2";